import type { ThemeConfig } from 'antd'

/**
 * Ant Design 5 Theme Configuration
 * Based on Zealys brand colors
 */
export const antdTheme: ThemeConfig = {
  token: {
    // Primary brand colors
    colorPrimary: '#3caef2',
    colorSuccess: '#52c41a',
    colorWarning: '#faad14',
    colorError: '#f5222d',
    colorInfo: '#3caef2',

    // Background colors
    colorBgBase: '#ffffff',
    colorBgContainer: '#ffffff',
    colorBgElevated: '#ffffff',
    colorBgLayout: '#f5f5f5', // Light background for layout

    // Text colors
    colorTextBase: '#1a1a1a',
    colorTextSecondary: '#666666',
    colorTextTertiary: '#999999',
    colorTextQuaternary: '#cccccc',

    // Border colors
    colorBorder: '#d9d9d9',
    colorBorderSecondary: '#e8e8e8',

    // Typography
    fontSize: 14,
    fontSizeHeading1: 38,
    fontSizeHeading2: 30,
    fontSizeHeading3: 24,
    fontSizeHeading4: 20,
    fontSizeHeading5: 16,
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',

    // Border radius
    borderRadius: 5,
    borderRadiusLG: 8,
    borderRadiusSM: 3,

    // Control heights
    controlHeight: 32,
    controlHeightLG: 40,
    controlHeightSM: 24,

    // Line height
    lineHeight: 1.5715,
    lineHeightHeading1: 1.21,
    lineHeightHeading2: 1.27,
    lineHeightHeading3: 1.33,
    lineHeightHeading4: 1.4,
    lineHeightHeading5: 1.5,
  },
  components: {
    // Table component customization
    Table: {
      colorBgContainer: '#ffffff',
      colorFillAlter: '#fafafa', // Striped row background
      colorBorderSecondary: '#e8e8e8',
      borderRadius: 5,
    },

    // Button component customization
    Button: {
      colorPrimary: '#3caef2',
      borderRadius: 5,
      controlHeight: 32,
      controlHeightLG: 40,
      controlHeightSM: 24,
    },

    // Input component customization
    Input: {
      colorBorder: '#d9d9d9',
      borderRadius: 5,
      controlHeight: 32,
    },

    // Select component customization
    Select: {
      colorBorder: '#d9d9d9',
      borderRadius: 5,
      controlHeight: 32,
    },

    // Modal component customization
    Modal: {
      borderRadius: 5,
      colorBgElevated: '#ffffff',
    },

    // Card component customization
    Card: {
      colorBgContainer: '#ffffff',
      borderRadius: 5,
    },

    // Drawer component customization
    Drawer: {
      colorBgElevated: '#ffffff',
    },

    // Layout component customization
    Layout: {
      colorBgBody: '#f5f5f5',
      colorBgHeader: '#ffffff',
      colorBgTrigger: '#002140',
    },

    // Menu component customization
    Menu: {
      colorItemBg: '#ffffff',
      colorItemBgSelected: '#edf8ff',
      colorItemBgHover: '#f5f5f5',
      colorActiveBarBorderSize: 3,
    },

    // Form component customization
    Form: {
      labelColor: '#1a1a1a',
      labelFontSize: 14,
    },

    // Message component customization
    Message: {
      colorBgElevated: '#ffffff',
    },

    // Notification component customization
    Notification: {
      colorBgElevated: '#ffffff',
    },

    // Tabs component customization
    Tabs: {
      colorBorderSecondary: '#e8e8e8',
    },

    // Badge component customization
    Badge: {
      colorError: '#f5222d',
    },

    // Tag component customization
    Tag: {
      colorBorder: '#d9d9d9',
      borderRadiusSM: 3,
    },

    // Spin component customization
    Spin: {
      colorPrimary: '#3caef2',
    },
  },
}
